import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { BeatLoader } from 'react-spinners';
// error notification box

// set up amplify config
import { Amplify, Auth } from 'aws-amplify';
import awsconfig from '../../aws-exports';

import '../../../src/styles/login.css';

import { addUser } from '../../redux/actions/addUser';

// Import generic components
import Input from '../../generic_components/Input/Input';
import Button from '../../generic_components/Button/Button';
import { useToast } from '../../generic_components/Toast/Toast';

Amplify.configure(awsconfig);

const SignUp = ({ onClose }) => {

    const [email, setEmail] =  useState('');
    const [password, setPassword] = useState('');
    const [confirmationCode, setConfirmationCode] = useState('');
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [loadingSignup, setLoadingSignup] = useState(false);
    const [loadingConfirmSignup, setLoadingConfirmSignup] = useState(false);
     const [showPassword, setShowPassword] = useState(false);

    const toast = useToast(); // global toast from ToastContext

    const dispatch = useDispatch();

    // const isSmallScreen = window.innerWidth < 600;
  
    const handleEmailChange = (e) => {
        setEmail(e.target.value.toLowerCase().replace(/\s+/g, ''));
    }

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    }

  async function resendConfirmationCode(username) {
    try {
        await Auth.resendSignUp(username);  
        setIsConfirmed(true);     
       
        // let errorMsg = `A confirmation code has been resent to ${username}`;
        // addToast(errorMsg, {
        //   appearance: 'error',
        //   autoDismiss: true,
        // });
       
    } catch (err) {
        console.log(err.message);
        if (err.message === 'User is already confirmed.') {
          
        let errorMsg = `User is already confirmed. You can sign in with this user.`;
        toast.error(errorMsg, {
          hideProgressBar: true
        });

        onClose();
        }
        else {
          toast.error(err.message, {
            hideProgressBar: true
          });
        }
       
    }
}

  const handleSignUp = async (e) => {
      e.preventDefault();        
      try {
        setLoadingSignup(true); // start rendering loading icon
        await Auth.signUp({
          username: email, // Use email as the username
          password,
          attributes: {
            email,
            // phone_number: phoneNumber
          },
          autoSignIn: {
            // optional - enables auto sign in after user is confirmed
            enabled: true,
          },
        });
      
        setIsConfirmed(true);
        setLoadingSignup(false);  // stop rendering loading icon      
      } catch (error) {
        setIsConfirmed(false);
        setLoadingSignup(false);  // stop rendering loading icon

        if (error.message === 'An account with the given email already exists.') {
          setLoadingSignup(true);
          await resendConfirmationCode(email);
          setLoadingSignup(false);             
        }
      
        else {
          toast.error(error.message, {
            hideProgressBar: true
          });
        }
        
      }
    };

      const confirmSignUp = async () => {
        try {
          setLoadingConfirmSignup(true);     // start rendering loading icon     
          await Auth.confirmSignUp(email, confirmationCode); // Use email for confirmation
          setLoadingConfirmSignup(false);  // stop rendering loading icon      
          // add user data into users table
          const userData = { email: email, signup_time: new Date() }
          dispatch(addUser(userData));

          let successMsg = "Your sign up was successful. Please login to continue.";
          toast.success(successMsg, {
            autoClose: 9000,
            hideProgressBar: true
          });

          onClose();
        } catch (error) {
          setLoadingConfirmSignup(false);  // stop rendering loading icon
          toast.error(error.message, {
            hideProgressBar: true
          });
        }
      };

       const handleShowPassword = () => {
    setShowPassword(prev => !prev);
  };


  return (
    <>
       
       
        {!isConfirmed ? (
          <form onSubmit={handleSignUp}>
              
                <Input
                id="email"              
                type="email"
                placeholder="Email"
                value={email}
                onChange={handleEmailChange}
                size='lg'
                />
                <br></br>

               <div style={{ position: 'relative' }}>
                <Input               
                type={showPassword ? "text":"password"}
                placeholder="Password"
                value={password}
                onChange={handlePasswordChange}
                size='lg'
                />
                <button className='show-password-btn' type='button' onClick={handleShowPassword}>
              {showPassword ? <i className="fa-regular fa-eye-slash"></i> : <i className="fa-regular fa-eye"></i> }
            </button>
                </div>
                <br></br>
                <Button type="submit" variant='primary' >Sign up</Button>

                { loadingSignup ?
                  <div style={{ marginTop: '0.0em', textAlign: 'center' }}>
                    <BeatLoader size={5} color="#36d7b7"/>
                  </div> :
                  <div style={{ marginTop: '0.0em', height: '1.5em' }}>
                  
                  </div> 
                }

             
              </form>

              ) :

            <div className='signin-password-container'>
                <Input
                  size='lg'
                  type="text"
                  placeholder="Enter confirmation Code"
                  value={confirmationCode}
                  onChange={(e) => setConfirmationCode(e.target.value)}
                />
                <div id='input-box-signup-confirmation-text' >
                  A confirmation code has been sent to: <br></br><strong >{email}</strong>
                </div>
                <Button onClick={confirmSignUp}>Confirm</Button>

                { loadingConfirmSignup ?
                  <div style={{ marginTop: '0.0em', textAlign: 'center' }}>
                    <BeatLoader size={5} color="#36d7b7"/>
                  </div> :
                  <div style={{ marginTop: '0.0em', height: '1.5em' }}>
                  
                  </div> 
                }
            </div>
        }
        
     </>
  )
}

export default SignUp